export const saffronURL =`https://saffronpages.com`
export const vURL =`https://virtualsevak.com`
export const saffronRout =`/saffron-pages`